import { FormActionButton } from '@workwave-tidal/core/form'

import { useEditingStateWithCtx } from '@/atoms'

import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'
import { emptyDepotId } from '../utils/createEmptyDepot'

export function Footer() {
  const { resetEditing } = useEditingStateWithCtx('depot')
  const { field: idField } = form.useFormField('id')
  const { footer } = useTexts()

  const creating = idField.value === emptyDepotId

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled = creating
    ? validating || submitting
    : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={footer.cancel}
        onClick={resetEditing}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={footer.submit(creating)}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
